<div class="flex flex-col !gap-5" [ngClass]="{ 'left-menu': mobileMenu }">
  <div *ngIf="mobileMenu" class="flex flex-row items-center justify-end">
    <button class="close-button" (click)="closeAccountMenu()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </button>
  </div>

  <div class="profile-summary flex flex-row items-center !p-5" [ngClass]="{ 'all-borders': mobileMenu }">
    <ion-avatar>
      <img [src]="userService.userG?.photoURL" />
      <ng-template #photoLoading>
        <ion-spinner class="spinner-loading" color="primary" name="crescent"></ion-spinner>
      </ng-template>
    </ion-avatar>

    <div class="flex flex-col">
      <span class="text-xl font-medium leading-none">{{ userService.userG?.displayName }}</span>
      <span class="text text-base font-normal">Mi cuenta</span>
    </div>
  </div>

  <ul class="menu-options flex flex-col">
    <ion-accordion-group [value]="accordionValue" (ionChange)="accordionValue = $any($event).detail.value">
      <ion-accordion value="profile">
        <div
          slot="header"
          class="flex flex-row items-center justify-between"
          (click)="toggleExpand()"
          [ngClass]="onProfile ? 'active' : ''"
        >
          <li class="menu-option bg-hover" [ngClass]="onProfile ? 'active-accordeon-header' : ''">
            <ion-icon src="../../../assets/icon/user.svg"></ion-icon>
            <span>Mi perfil</span>
          </li>
          <ion-icon class="arrow" [ngClass]="{ rotated: expand }" src="../../../assets/icon/flechaAbajo.svg"></ion-icon>
        </div>
        <div slot="content" class="expanded-options flex flex-col">
          <li
            [routerLink]="['/account', 'mi-perfil', 'datos-cuenta']"
            [routerLinkActive]="'selected-option'"
            class="menu-option"
          >
            <ion-icon src="../../../assets/icon/user.svg"></ion-icon>
            <span>Mis datos de la cuenta</span>
          </li>
          <li
            [routerLink]="['/account', 'mi-perfil', 'datos-envio']"
            [routerLinkActive]="'selected-option'"
            class="menu-option"
          >
            <ion-icon src="../../../assets/icon/camion.svg"></ion-icon>
            <span>Datos de envío</span>
          </li>
          <li
            [routerLink]="['/account', 'mi-perfil', 'datos-facturacion']"
            [routerLinkActive]="'selected-option'"
            class="menu-option"
          >
            <ion-icon src="../../../assets/icon/accounting-invoice.svg"></ion-icon>
            <span>Datos de facturación</span>
          </li>
        </div>
      </ion-accordion>
    </ion-accordion-group>
    <li [routerLink]="['/account', 'pedidos']" [routerLinkActive]="'active'" class="menu-option bg-hover">
      <ion-icon src="../../../assets/icon/shopping-bag-sad.svg"></ion-icon>
      <span>Mis pedidos</span>
    </li>
    <li [routerLink]="['/account', 'embajadores']" [routerLinkActive]="'active'" class="menu-option bg-hover">
      <ion-icon src="../../../assets/icon/panelEmbajadores.svg"></ion-icon>
      <span>Panel de embajador</span>
    </li>
    <li [routerLink]="['/account', 'wallet']" [routerLinkActive]="'active'" class="menu-option bg-hover">
      <ion-icon src="../../../assets/icon/bonoMonedero.svg"></ion-icon>
      <span>Bono monedero</span>
    </li>
    <li (click)="doLogout()" class="logout menu-option">
      <ion-icon src="../../../assets/icon/cerrarSesion.svg"></ion-icon>
      <span>Cerrar sesión</span>
    </li>
  </ul>
</div>
